// extracted by mini-css-extract-plugin
export var cardSelected = "_f8-2";
export var image = "_f8-1";
export var table = "_f8-0";